export default __webpack_public_path__ + "static/media/modely.4549391a.jfif";